module.exports = __webpack_public_path__ + "static/media/background-stars.2bf75e71.svg";